import { FC } from 'react';
import { cn } from '../lib';
import { Typography } from './Typography';
import { useRTL } from '../hooks/useRTL';

interface ErrorMessageProps {
  text: string;
  className?: string;
}

export const InputErrorMessage: FC<ErrorMessageProps> = ({ text, className }) => {
  const isRTL = useRTL();

  return (
    <Typography variant='subtitle1' color='destructive' className={cn('mt-2', isRTL && 'text-right', className)}>
      {isRTL ? `${text}*` : `*${text}`}
    </Typography>
  );
};
